var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowCurved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.709,
    height: 78.428,
    viewBox: "0 0 86.709 78.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    transform: "translate(-951.696 -360.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_96",
    "data-name": "Trazado 96",
    d: "M-174.245-4644.878s70.984-2.786,76.47,64.552",
    transform: "translate(1126 5007)",
    fill: "none",
    stroke: "#0071dc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    "data-name": "Trazado 97",
    d: "M-112.34-4580.327l9.009,12.438,9.009-12.437Z",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 1609.685, 4970.142)",
    fill: "#0071dc"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurved);
export default __webpack_public_path__ + "static/media/arrowCurved.bbc79eb844a0b01d341cc4292b678559.svg";
export { ForwardRef as ReactComponent };